import { StatusRefund } from "../shared/enums/StatusRefund";
import { Approver } from "./Approver.model";
import { Company } from './billing-letter/Company.model';
import * as _ from 'lodash';

export interface Dimension {
    _id: String;
    name: String;
    sapCode: String;
    value: number;
    percentage: number;
};

export interface Ratio {
    excellenceCenters: Dimension[];
    industries: Dimension[];
    supportCenters: Dimension[];
};

export interface Item {
    sapItemCode: string;
    itemName: string,
    division: number,
    value: number,
    quantity: number,
    project: {
      _id: string,
      name: string,
      sapProjectId: string
    },
    customer: {
      _id: string,
      name: string,
      sapCardCode: string
    },
    companyGroup: {
      _id: string,
      name: string
    },
    percent?: any,
    hasApportionment?: boolean,
    excellenceCenters?: Dimension[],
    industries?: Dimension[],
    supportCenters?: Dimension[]
}

export interface BlanketAgreementInvoice {
    sapDocEntry: string;
    sapDocNum: string;
    value: number;
    nf: string;
    competence: number;
    competenceYear: number;
    dueDate: Date;
}

export interface FormattedItemsForBlanketAgreementInvoice {
    sapItemCode: string[],
    itemName: string[],
    value: number[],
    _id: string[],
    companyGroup: string,
    customer: string,
    project: string,
    quantity: number[]
}

export type PurchaseOrderRecurrence = {
    competence: number;
    competenceYear: number;
    dueDate: Date;
    recurrent?: number;
    value: number;
}

export type Anticipation = {
    startDate: string;
    endDate: string;
}

export class PurchaseOrder {
    _id: String;
    company: Company = new Company();
    value: number = 0;
    status: StatusRefund;
    created: Date;
    changed: Date;
    requester: Approver = new Approver();
    observation: String;
    cancellationReason: String;
    origin: Number = 1;
    sapDocEntry: String;
    sapDocNum: String;
    emails: String[] = new Array<String>();
    sapIntegrated: Boolean = false;
    competence: Number = 0;
    subDivision: any = [];
    competenceYear: Number = 0;
    dueDate: Date;
    paymentDate: Date;
    startDate: Date;
    endDate: Date;
    managers: any = [];
    items: Item[] = [];
    transcriptManagers: String = '';
    transcriptDivisions: String = '';
    transcriptSubDivisions: String = '';
    isApprover: Boolean = false;
    sendEmailToApprover: Boolean = true;
    objProjectFinancials: any;
    purchaseJoin: String;
    approvalDate: Date;
    quantity: Number = 1;
    excellenceCenters: Dimension[] = [];
    industries: Dimension[] = [];
    supportCenters: Dimension[] = [];
    blanketAgreementInvoices: BlanketAgreementInvoice[] = [];
    blanketAgreementCode: string = '';
    isBlanketAgreement: boolean = false;
    blanketAgreementRemainingValue: number;
    blanketAgreementAccumulatedValue: number;
    anticipationCode: string = '';
    anticipation: Anticipation;
    paymentMethod: number = 0;
    hasAttachment: boolean = false;

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        })
    }

    loadFromServer(r: any) {

        this._id = r._id;

        if (r.company)
            this.company = r.company;

        if (r.value !== undefined)
            this.value = parseFloat(r.value);

        if (r.status !== undefined)
            this.status = parseInt(r.status);

        if (r.subDivision !== undefined)
            this.subDivision = r.subDivision;

        if(r.requester !== undefined)
            this.requester.loadFromServer(r.requester);

        if(r.observation)
            this.observation = r.observation;

        if (r.origin !== undefined)
            this.origin = parseInt(r.origin);

        if(r.sapDocEntry)
            this.sapDocEntry = r.sapDocEntry;

        if(r.sapDocNum)
            this.sapDocNum = r.sapDocNum;

        if(r.sapIntegrated !== undefined)
            this.sapIntegrated = r.sapIntegrated;

        if(r.competence)
            this.competence = r.competence;

        if(r.paymentDate)
            this.paymentDate = r.paymentDate;

        if(r.competenceYear)
            this.competenceYear = r.competenceYear;

        if(r.dueDate)
            this.dueDate = r.dueDate;

        if(r.items)
            this.items = r.items;

        if(r.managers)
            this.managers = r.managers;

        if(r.purchaseJoin)
            this.purchaseJoin = r.purchaseJoin;

        if (r.supportCenters)
            this.supportCenters = r.supportCenters;

        if (r.excellenceCenters)
            this.excellenceCenters = r.excellenceCenters;

        if (r.industries)
            this.industries = r.industries;

        if (r.approvalDate)
            this.approvalDate = r.approvalDate;

        if (r.blanketAgreementCode)
            this.blanketAgreementCode = r.blanketAgreementCode;

        if (r.blanketAgreementInvoices)
            this.blanketAgreementInvoices = [...r.blanketAgreementInvoices]

        if (r.isBlanketAgreement !== undefined)
            this.isBlanketAgreement = r.isBlanketAgreement

        if (r.blanketAgreementRemainingValue !== undefined)
            this.blanketAgreementRemainingValue = r.blanketAgreementRemainingValue;

        if (r.blanketAgreementAccumulatedValue !== undefined)
            this.blanketAgreementAccumulatedValue = r.blanketAgreementAccumulatedValue;

        if(r.startDate)
            this.startDate = r.startDate;

        if(r.endDate)
            this.endDate = r.endDate;

        if (r.anticipationCode)
            this.anticipationCode = r.anticipationCode;

        if (r.emails)
            this.emails = r.emails;

        if(r.paymentMethod)
            this.paymentMethod = r.paymentMethod;

        if (r.hasAttachment !== undefined)
            this.hasAttachment = r.hasAttachment;

        if (r.anticipation && !!r.anticipation.startDate && !!r.anticipation.endDate)
            this.anticipation = r.anticipation;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/PurchaseOrder.model.ts